"use strict";

var iteratorSymbol = require("es6-symbol").iterator
  , isValue        = require("../object/is-value")
  , isArrayLike    = require("../object/is-array-like");

module.exports = function (value) {
	if (!isValue(value)) return false;
	if (typeof value[iteratorSymbol] === "function") return true;
	return isArrayLike(value);
};
